import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  accountRouteProps,
  AccountSettingsMatchParams,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<AccountSettingsMatchParams>(
      backgroundLocation.pathname,
      accountRouteProps,
    ) as match<AccountSettingsMatchParams>
    return mtch.params.id
  },
)

export const selectPutCreditCardErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.account.accountSettings.putCreditCardErrorDetailMap
export const selectPutCreditCardTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.account.accountSettings.putCreditCardTopLevelError
export const selectPuttingCreditCardFromState = (state: RootState): boolean =>
  state.app.account.accountSettings.puttingCreditCard
export const selectPuttingCreditCardAccountFromState = (
  state: RootState,
): boolean => state.app.account.accountSettings.puttingCreditCardAccount
export const selectPuttingCreditCardBillingFromState = (
  state: RootState,
): boolean => state.app.account.accountSettings.puttingCreditCardBilling
export const selectPutCreditCardAccountCausedErrorFromState = (
  state: RootState,
): boolean => state.app.account.accountSettings.putCreditCardAccountCausedError
export const selectPutCreditCardBillingCausedErrorFromState = (
  state: RootState,
): boolean => state.app.account.accountSettings.putCreditCardBillingCausedError
export const selectPatchingCreditCardFromState = (state: RootState): boolean =>
  state.app.account.accountSettings.patchingCreditCard
export const selectReplaceCreditCardErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.account.accountSettings.replaceCreditCardErrorDetailMap
export const selectReplaceCreditCardTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.account.accountSettings.replaceCreditCardTopLevelError
